import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Button } from "../../components/ui/button";
import { Check, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminComments() {
  const { authHeaders } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => { load(); }, []);
  const load = async () => {
    const { data } = await api.get("/admin/comments", { headers: authHeaders() });
    setItems(data);
  };
  const toggleApprove = async (c) => {
    await api.put(`/admin/comments/${c.id}`, { is_approved: !c.is_approved }, { headers: authHeaders() });
    load();
  };
  const remove = async (id) => {
    if (!confirm("Delete?")) return;
    await api.delete(`/admin/comments/${id}`, { headers: authHeaders() });
    load();
  };

  return (
    <div data-testid="admin-comments">
      <h1 className="text-3xl font-extrabold mb-6">Comments</h1>
      <div className="space-y-4">
        {items.map((c) => (
          <div key={c.id} className="bg-white rounded-2xl border border-slate-200 p-6">
            <div className="flex justify-between items-start mb-2">
              <div>
                <div className="font-bold">{c.name}</div>
                <div className="text-xs text-slate-500">On: /blog/{c.post_slug}</div>
              </div>
              {c.is_approved ? (
                <span className="px-2 py-0.5 bg-emerald-50 text-emerald-700 text-xs font-bold rounded">Approved</span>
              ) : (
                <span className="px-2 py-0.5 bg-amber-50 text-amber-700 text-xs font-bold rounded">Pending</span>
              )}
            </div>
            <p className="text-slate-700 mb-3">{c.content}</p>
            <div className="flex gap-2">
              <Button size="sm" onClick={() => toggleApprove(c)} className="bg-brand-pink hover:bg-brand-pink-hover">
                <Check className="w-3.5 h-3.5 mr-1" /> {c.is_approved ? "Unpublish" : "Approve"}
              </Button>
              <Button size="sm" variant="outline" onClick={() => remove(c.id)}>
                <Trash2 className="w-3.5 h-3.5 text-red-500" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
